export default "__VITE_ASSET__TsF5jUU1__"